import React from 'react';
import Loans_Deduction from './Loans_Deduction';
import '../../../CommonCSS/SocietyCSS.css'

const Loans_DeductionApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Loans & Advances</h5>
          </div>  
        </div>
        <Loans_Deduction/>
      </div>
    </div >
  );
};

export default Loans_DeductionApp;
